var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPath2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    fill: "currentColor",
    className: "bi bi-trash3",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 1h3a.5.5 0 01.5.5v1H5v-1a.5.5 0 01.5-.5M10 2.5v-1A1.5 1.5 0 008.5 0h-3A1.5 1.5 0 004 1.5v1H.5a.5.5 0 000 1h.538l.853 10.66A2 2 0 003.885 16h6.23a2 2 0 001.994-1.84l.853-10.66h.538a.5.5 0 000-1zm1.958 1l-.846 10.58a1 1 0 01-.997.92h-6.23a1 1 0 01-.997-.92L2.042 3.5zm-7.487 1a.5.5 0 01.528.47l.5 8.5a.5.5 0 01-.998.06L4 5.03a.5.5 0 01.47-.53zm5.058 0a.5.5 0 01.47.53l-.5 8.5a.5.5 0 11-.998-.06l.5-8.5a.5.5 0 01.528-.47M7 4.5a.5.5 0 01.5.5v8.5a.5.5 0 01-1 0V5a.5.5 0 01.5-.5",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath2);
export default __webpack_public_path__ + "static/media/path2.b172e5e4f9fbf9d588e3b65ab2670050.svg";
export { ForwardRef as ReactComponent };